import styled from 'styled-components';

import theme from '../../theme';

export const ClientJobContainerStyled = styled.div`
  margin-top: 18px;
  background-color: ${theme.colors.white};
  padding: 30px 20px;

  @media (max-width: ${theme.breakpoints.md}) {
    background-color: ${theme.colors.lighterBackground};
  }
  & .table-container {
    margin-bottom: 20px;
  }
`;
export const ClientJobStyled = styled.div`
  margin-top: 18px;

  & .flag {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 12px;
    margin-bottom: -5px;
  }

  @media (max-width: ${theme.breakpoints.md}) {
    & .data-row .actions button {
      background-color: transparent;
      color: ${theme.colors.secondary};
      border: 0px;
    }
  }
`;
